// import React, {useEffect, useMemo} from 'react';
// import Leaflet from 'leaflet';
// import {TileLayer, Marker, useMapEvents} from 'react-leaflet'
// import {createControlComponent} from '@react-leaflet/core';
// import 'leaflet-routing-machine';
//
// import {useToast} from '../../../../common/hook/toast';
//
// const RoutingMachine = props => {
//     const {callToast} = useToast()
//
//     // -----------------------------------------------------------------------------------------------------------------
//
//     const createRoutineMachineLayer = () => {
//
//         return Leaflet.Routing.control({
//             waypoints: [Leaflet.latLng(props.data[0][0], props.data[0][1]), Leaflet.latLng(props.data[1][0], props.data[1][1])],
//             lineOptions: {
//                 styles: [{color: 'var(--bs-primary)', weight: 4}]
//             },
//             show: false,
//             addWaypoints: false,
//             routeWhileDragging: true,
//             draggableWaypoints: true,
//             fitSelectedRoutes: true,
//             showAlternatives: false
//         })
//         // }).on('routingstart', e => {
//         //
//         // }).on('routesfound', e => {
//         //
//         // }).on('routingerror', e => {
//         //     callToast('secondary', null, null, 'از موقعیت شما به میکامال مسیری یافت نشد');
//         // });
//
//     };
//
//     useEffect(() => {
//
//         Leaflet.Routing.on('routingerror', e => {
//             callToast('secondary', null, null, 'از موقعیت شما به میکامال مسیری یافت نشد');
//         });
//
//     }, [])
//
//     // -----------------------------------------------------------------------------------------------------------------
//
//     return useMemo(() => {
//
//         return React.createElement(createControlComponent(createRoutineMachineLayer))
//
//     }, [])
// }
//
// export default RoutingMachine;

import React, {useEffect} from 'react';
import Leaflet from 'leaflet';
import 'leaflet-routing-machine';
// import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';

import {useToast} from '../../../common/hook/toast';

let routingControl;

const RoutingMachine = props => {
    const {callToast} = useToast()

    useEffect(() => {

        routingControl = Leaflet.Routing.control({
            waypoints: [Leaflet.latLng(props.data[0][0], props.data[0][1]), Leaflet.latLng(props.data[1][0], props.data[1][1])],
            lineOptions: {
                styles: [{color: 'var(--bs-primary)', weight: 4}]
            },
            show: false,
            addWaypoints: false,
            routeWhileDragging: true,
            draggableWaypoints: true,
            fitSelectedRoutes: true,
            showAlternatives: false
        }).addTo(props.data[2]);

        return () => props.data[2].removeControl(routingControl);

    }, [props.data[2]]);

    useEffect(() => {

        routingControl.on('routesfound ', e => {

            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:first-child').classList.add('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:nth-child(2)').classList.add('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:last-child').classList.remove('d-none')

        })

        routingControl.on('routingerror', e => {

            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:first-child').classList.remove('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:nth-child(2)').classList.add('d-none')
            document.querySelector('#pageGettingHere .leaflet-container #divRoute button:last-child').classList.add('d-none')

            callToast('secondary', null, null, 'از موقعیت شما به میکامال مسیری یافت نشد');

        })

    }, [])

    return null;
}

export default RoutingMachine;